import Message from 'shared_components/message';
import { axiosLabAPI } from 'services/axios';
import { API_GET_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export default async function getInputTypeCode() {
	let inputTypeCodes = [];

	try{
		const content = {
			method: API_GET_METHOD,
			url: 'listofvalues/examresultinputtype',
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			inputTypeCodes = data.RECORDS;
		  }
	  
	}
	catch(e) {
		showMessage(e);
	}

	return inputTypeCodes;
}